<!-- eslint-disable vue/html-self-closing -->
<template>
  <section class="gf-user-card">
    <gf-entity-card
      :description="role.length === 0 ? bio : null"
      :description-lines-number="1"
      :is-short-title="true"
    >
      <template #headerTitle>
        <img
          class="avatar"
          :src="avatar"
        />
        <div class="gf-user-card__header">
          <div class="info">
            <div class="name">
              <div class="title">
                <h6 class="mb-0">
                  <a :href="userLink">{{ fullname }}</a>
                </h6>
              </div>
              <gf-verification-icon
                v-if="verificationType"
                :verification-type="verificationType"
                :basic-verification-title="$t('user.verified')"
                size="3"
              />
            </div>
            <div class="title username">
              <span class="text-muted">@{{ username }}</span>
            </div>
          </div>
          <div
            v-if="
              (bio.length === 0 &&
                (company?.length > 0 || publicProjectCount > 0 || followersCountModel > 0)) ||
              role?.length > 0
            "
            class="statistics"
          >
            <span v-if="company?.length > 0">
              <i class="gf-icon gf-icon-companies gf-fs-2 mr-1"></i>
              {{ company }}
            </span>
            <span v-if="publicProjectCount > 0">
              <i class="gf-icon gf-icon-folder gf-fs-2 mr-1"></i>
              {{ publicProjectCount || 0 }}
            </span>
            <span v-if="followersCountModel > 0">
              <i class="gf-icon gf-icon-group gf-fs-2 mr-1"></i>
              {{ formatOutputNumber(followersCountModel) }}
            </span>
          </div>
          <span
            v-if="role?.length > 0"
            class="mobile-label gf-topic-badge mr-2"
          >
            <i class="gf-icon gf-icon-person mr-1"></i>
            <b>{{ role }}</b>
          </span>
        </div>
      </template>
      <template
        v-if="bio?.length === 0 || role?.length > 0"
        #additionalActions
      >
        <div class="gf-user-card__footer-actions">
          <span
            v-if="role?.length > 0"
            class="gf-topic-badge mr-2"
          >
            <i class="gf-icon gf-icon-person mr-1"></i>
            <b>{{ role }}</b>
          </span>
          <div
            class="gf-user-card__star"
            v-if="username !== authUserAlias"
          >
            <button
              class="btn btn-sm"
              type="button"
              @click="followUser"
            >
              <i
                class="gf-icon mr-1 gf-fs-2"
                :class="starIconClass"
              ></i>
              <small>{{ starText }}</small>
            </button>
          </div>
          <button
            class="btn btn-sm gf-tooltip-temporary"
            type="button"
            :class="{ '--show-tooltip': showCopyTooltip }"
            data-tooltip-text="Скопировано!"
            @click="shareUser"
          >
            <i
              class="gf-icon gf-fs-2"
              :class="shareFieldIcon"
            ></i>
          </button>
        </div>
      </template>
      <template
        v-if="
          bio.length > 0 &&
          (company?.length > 0 || publicProjectCount > 0 || followersCountModel > 0) &&
          role.length === 0
        "
        #footerContent
      >
        <div class="gf-user-card__footer-content">
          <span v-if="company?.length > 0">
            <i class="gf-icon gf-icon-companies gf-fs-2 mr-1"></i>
            {{ company }}
          </span>
          <span v-if="publicProjectCount > 0">
            <i class="gf-icon gf-icon-folder gf-fs-2 mr-1"></i>
            {{ publicProjectCount || 0 }}
          </span>
          <span v-if="followersCountModel > 0">
            <i class="gf-icon gf-icon-group gf-fs-2 mr-1"></i>
            {{ formatOutputNumber(followersCountModel) }}
          </span>
        </div>
      </template>
      <template
        v-if="bio?.length > 0 && role.length === 0"
        #footerActions
      >
        <div class="gf-user-card__footer-actions">
          <div
            class="gf-user-card__star"
            v-if="username !== authUserAlias"
          >
            <button
              class="btn btn-sm"
              type="button"
              @click="followUser"
            >
              <i
                class="gf-icon mr-1 gf-fs-2"
                :class="starIconClass"
              ></i>
              <small>{{ starText }}</small>
            </button>
          </div>
          <button
            class="btn btn-sm gf-tooltip-temporary"
            type="button"
            :class="{ '--show-tooltip': showCopyTooltip }"
            data-tooltip-text="Скопировано!"
            @click="shareUser"
          >
            <i
              class="gf-icon gf-fs-2"
              :class="shareFieldIcon"
            ></i>
          </button>
        </div>
      </template>
      <template #mobileFooterActions>
        <div class="gf-user-card__footer-actions --mobile">
          <button
            v-if="username !== authUserAlias"
            class="btn btn-sm star-button"
            type="button"
            :class="{ '--starred': isFollowedModel }"
            @click="followUser"
          >
            <i
              class="gf-icon"
              :class="starIconMobileClass"
            ></i>
          </button>
          <button
            class="btn btn-sm gf-tooltip-temporary"
            type="button"
            :class="{ '--show-tooltip': showCopyTooltip }"
            data-tooltip-text="Скопировано!"
            @click="shareUser"
          >
            <i
              class="gf-icon"
              :class="shareFieldIcon"
            ></i>
          </button>
        </div>
      </template>
    </gf-entity-card>
  </section>
</template>

<script>
import GfEntityCard from '@shared/shared-components/shared/GfEntityCard';
import HelperS from '@shared/services/helper.service';
import GfVerificationIcon from '@shared/shared-components/shared/GfVerificationIcon';
import UserService from '@/shared-modules/modules/user/user.service';
import UserMessages from '@/shared-modules/modules/user/user.messages';

export default {
  name: 'GfUserCardStatic',
  components: { GfEntityCard, GfVerificationIcon },
  props: {
    bio: {
      type: String,
      default: ''
    },
    avatar: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    surname: {
      type: String,
      default: ''
    },
    fullname: {
      type: String,
      default: ''
    },
    verificationType: {
      type: String,
      default: null
    },
    username: {
      type: String,
      default: ''
    },
    company: {
      type: String,
      default: ''
    },
    publicProjectCounter: {
      type: String,
      default: '0'
    },
    isFollowed: {
      type: String,
      default: 'false'
    },
    followersCounter: {
      type: String,
      default: '0'
    },
    role: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      shareFieldIcon: 'gf-icon-share-social',
      isFollowedModel: false,
      followersCountModel: 0,
      showCopyTooltip: false
    };
  },
  computed: {
    userLink() {
      return `/user/${this.username}`;
    },
    starIconClass() {
      return this.isFollowedModel ? 'gf-icon-star-fill text-warning' : 'gf-icon-star';
    },
    starText() {
      return this.isFollowedModel ? this.$t('user.isFollowed') : this.$t('user.follow');
    },
    starIconMobileClass() {
      return this.isFollowedModel ? 'gf-icon-star-fill' : 'gf-icon-star text-muted';
    },
    publicProjectCount() {
      return parseInt(this.publicProjectCounter) || 0;
    },
    followed() {
      return this.isFollowed === 'true';
    },
    followersCount() {
      return parseInt(this.followersCounter) || 0;
    },
    isUserAuthtorized() {
      return this.$store.getters.getIsUserAuthtorized;
    },
    authUserAlias() {
      return this.$store.getters.getUserAlias;
    }
  },
  mounted() {
    this.isFollowedModel = this.followed;
    this.followersCountModel = this.followersCount || 0;
  },
  methods: {
    followUser() {
      if (this.isUserAuthtorized) {
        if (this.isFollowedModel) this.followersCountModel -= 1;
        else this.followersCountModel += 1;

        const followMethod = this.isFollowedModel
          ? UserService.unfollowUser
          : UserService.followUser;
        followMethod(this.username).then(() => {
          this.isFollowedModel = !this.isFollowedModel;
        });
      } else {
        window.location = '/auth/login';
      }
    },
    shareUser() {
      const shareData = {
        title: this.$t('user.inGitflic', { name: `${this.fullname}` }),
        url: this.userLink
      };
      if (!HelperS.share(shareData)) {
        this.shareFieldIcon = 'gf-icon-check';
        this.showCopyTooltip = true;
        setTimeout(() => {
          this.showCopyTooltip = false;
          this.shareFieldIcon = 'gf-icon-share-social';
        }, 1500);
      }
    },
    formatOutputNumber(number) {
      return HelperS.formatOutputNumber(number, 0);
    }
  },
  i18n: {
    messages: UserMessages
  }
};
</script>

<style lang="scss">
$this: '.gf-user-card';

#{$this} {
  #{$this}__header {
    width: calc(100% - 58px);
    display: flex;
    flex-direction: column;
    gap: 8px;

    & .info {
      display: flex;
      flex-direction: column;
      gap: 2px;

      @media screen and (min-width: 768px) {
        flex-direction: row;
        align-items: center;
        gap: 8px;
      }

      & .name {
        display: flex;
        align-items: center;
        gap: 6px;
      }

      & > * {
        max-width: 200px;

        @media screen and (min-width: 768px) {
          max-width: 150px;
        }
        @media screen and (min-width: 1200px) {
          max-width: 300px;
        }
      }
    }

    & .statistics {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  #{$this}__footer-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;

    & > span {
      flex-wrap: wrap;
    }
  }
  #{$this}__footer-actions {
    display: flex;
    text-wrap: nowrap;
    gap: 8px;

    & button {
      & > i {
        font-size: 14px !important;
      }
    }

    #{$this}__star {
      display: flex;
      align-items: center;
      gap: 2px;

      & .project-badge.--starred {
        color: #000;
        background-color: var(--warning);
      }
    }

    &.--mobile {
      & > button {
        min-height: 32px !important;
        padding: 8px;
        background-color: var(--bg-light);
        border-radius: 6px;

        &.star-button {
          &.--starred {
            background-color: var(--warning);
            color: var(--light);
          }
        }

        &:hover {
          background-color: var(--bg-light-selected);
        }
      }
    }

    & button {
      min-height: 22px;
      padding: 0px 2px;

      &:focus {
        box-shadow: none;
      }
    }
  }
}
</style>
